import React, { Component } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { debounce } from 'lodash';

import './FeaturedWork.css';

const slideStyles = [
  {backgroundColor: '#0e4883', color: '#fff'},
  {backgroundColor: '#9d3136', color: '#fff'},
  {backgroundColor: '#75232d', color: '#fff'},
  {backgroundColor: '#014b95', color: '#fff'},
  {backgroundColor: '#c64537', color: '#fff'}
]

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export default class FeaturedWork extends Component {

  constructor(props) {
    super(props);

    this.videos = [];
    this.state = {
      index: 0
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', debounce((e) => {
      this.videos.map((video) => {
        console.log('playing video')
        video.play();
        return undefined
      })
    }, 100))
  }

  onChangeIndex = (index) => {
    this.setState({
      index: Math.min(slideStyles.length - 1, Math.max(0, Math.round(index)))
    })
  }

  showNext = (e) => {
    e.preventDefault();
    let index = this.state.index + 1;
    if(index > slideStyles.length - 1) {
      index = 0;
    }
    this.setState({index});
  }

  showPrevious = (e) => {
    e.preventDefault();
    let index = this.state.index - 1;
    if(index < 0) {
      index = slideStyles.length - 1;
    }
    this.setState({index});
  }

  addVideoRef = (video) => {
    if(video !== null && this.videos.indexOf(video) < 0) {
      this.videos.push(video);
    }
  }

  renderActionButton = (text, url) => {
    return (
      <a className="featured-work-action-button" href={url} target="_blank" rel="noopener noreferrer">
        <i className="material-icons">launch</i>
        {text}
      </a>
    )
  }

  render() {
    let {index} = this.state;
    let slideStyle = slideStyles[index];

    return (
      <section id="work" className="featured-work-section section-emphasis" style={slideStyle}>
        <h2 className="section-header">Featured work</h2>
        <AutoPlaySwipeableViews
          autoplay={false}
          enableMouseEvents
          interval={5000}
          onSwitching={this.onChangeIndex}
          onChangeIndex={this.onChangeIndex}
          index={index}
          resistance={true}
          slideStyle={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>

          <div className="featured-work-slide">
            <div className="featured-work-slide-content">
              <div className="featured-work-preview-mobile">
                <video autoPlay loop muted playsInline ref={(video) => { this.addVideoRef(video) }}>
                  <source src={require('../assets/videos/bussitre.mp4')} type='video/mp4' />
                </video>
              </div>
              <div className="featured-work-icon-wrapper">
                <img src={require('../assets/images/bussitre-icon.png')} alt="" />
              </div>
              <div className="featured-work-content">
                <h3>BussiTre iOS App</h3>
                <p>
                  BussiTre shows locations of Tampere City Transport buses on a map.
                  It's currently being used more than 50.000 times every month!
                </p>
                <ul className="featured-work-features">
                  <li>UX &amp; UI Design</li>
                  <li>Visual &amp; Icon Design</li>
                  <li>React Native Development</li>
                  <li>iOS App Publishing &amp; Management</li>
                  <li>Google AdMob Monetization</li>
                </ul>
                {this.renderActionButton("App Store", "https://itunes.apple.com/fi/app/id1089476552")}
              </div>
            </div>
          </div>

          <div className="featured-work-slide">
            <div className="featured-work-slide-content">
              <div className="featured-work-preview-desktop">
                <img src={require('../assets/images/likesofus.png')} alt="" />
              </div>
              <div className="featured-work-content">
                <h3>Likes of Us Band Branding &amp; Website</h3>
                <p>
                  Visual identity for my indie rock band "Likes of Us".
                </p>
                <ul className="featured-work-features">
                  <li>Logo &amp; Graphic Design</li>
                  <li>Web Design &amp; Development</li>
                  <li>Photo Editing</li>
                  <li>Social Media Marketing</li>
                  <li>(Audio &amp; Video Production)</li>
                </ul>
                {this.renderActionButton("Visit the page", "http://likesofus.band")}
                {this.renderActionButton("Listen on Spotify", "https://open.spotify.com/artist/5mJIuezXfKG3dxoCV5AXDl")}
              </div>
            </div>
          </div>

          <div className="featured-work-slide">
            <div className="featured-work-slide-content">
              <div className="featured-work-preview-mobile featured-work-preview-mobile-2">
                <video autoPlay loop muted playsInline ref={(video) => { this.addVideoRef(video) }}>
                  <source src={require('../assets/videos/beerpong.mp4')} type='video/mp4' />
                </video>
              </div>
              <div className="featured-work-content">
                <h3>AR Beer Pong for iOS</h3>
                <p>
                  (Proof of concept) Implementing an augmented reality beer pong game for iOS devices using Unity and Apple ARKit.
                  Multiplayer features will be included at some point. Not available for download.
                </p>
                <ul className="featured-work-features">
                  <li>UX &amp; UI Design</li>
                  <li>Unity &amp; C# Development</li>
                  <li>Apple ARKit Utilization</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="featured-work-slide">
            <div className="featured-work-slide-content">
              <div className="featured-work-content">
                <h3>Various Projects At Intopalo Digital</h3>
                <p>
                  Confidential client projects while working as a Senior Software Developer &amp; Designer at <a href="https://www.intopalo.com" target="_blank" rel="noopener noreferrer">Intopalo Digital</a> (March 2018 - present) including tasks like:
                </p>
                <ul className="featured-work-features">
                  <li>UX &amp; UI Design</li>
                  <li>Web Development (Frontend &amp; Backend)</li>
                  <li>Mobile VR Development (Unity)</li>
                  <li>Web Frontend Tech Lead Role</li>
                  <li>Consulting</li>
                </ul>
                <p>
                  Project domains including but not limited to:
                </p>
                <ul className="featured-work-features">
                  <li>Industry &amp; Agriculture</li>
                  <li>Reporting</li>
                  <li>Education</li>
                  <li>Information Security</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="featured-work-slide">
            <div className="featured-work-slide-content">
              <div className="featured-work-content">
                <h3>Various Projects At Leonidas</h3>
                <p>
                  Confidential client projects while working at <a href="https://leonidasoy.fi" target="_blank" rel="noopener noreferrer">Leonidas</a> (January 2011 - February 2018) including tasks like:
                </p>
                <ul className="featured-work-features">
                  <li>UX, UI &amp; Graphic Design</li>
                  <li>Web Development (Frontend &amp; Backend)</li>
                  <li>iOS &amp; Android Development</li>
                  <li>Augmented Reality Development (Unity &amp; ARKit)</li>
                  <li>Rapid Prototyping</li>
                  <li>Consulting</li>
                </ul>
                <p>
                  Project domains including but not limited to:
                </p>
                <ul className="featured-work-features">
                  <li>Metrics &amp; Analytics</li>
                  <li>Map Based Data Visualization</li>
                  <li>UI Component Library Development</li>
                  <li>Games &amp; Education</li>
                </ul>
              </div>
            </div>
          </div>

        </AutoPlaySwipeableViews>

        <div className="featured-work-dots">
          {
            slideStyles.map((style, i) => {
              let className = index === i ? 'active' : ''
              return (
                <span
                  key={i}
                  href='#'
                  className={className}
                  onClick={(e) => this.onChangeIndex(i)} />
              )
            })
          }
        </div>

        <a href='#back' className='featured-work-arrow featured-work-arrow-back' onClick={this.showPrevious}><i className="material-icons">arrow_back</i></a>
        <a href='#forward' className='featured-work-arrow featured-work-arrow-forward' onClick={this.showNext}><i className="material-icons">arrow_forward</i></a>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FeaturedWork.js